/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Shot_NumberInputs */

const en_ccsl_export_header_shot_number = /** @type {(inputs: Ccsl_Export_Header_Shot_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot #`)
};

const fr_ccsl_export_header_shot_number = /** @type {(inputs: Ccsl_Export_Header_Shot_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan #`)
};

const de_ccsl_export_header_shot_number = /** @type {(inputs: Ccsl_Export_Header_Shot_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schuss #`)
};

const it_ccsl_export_header_shot_number = /** @type {(inputs: Ccsl_Export_Header_Shot_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparo #`)
};

const ru_ccsl_export_header_shot_number = /** @type {(inputs: Ccsl_Export_Header_Shot_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выстрелил #`)
};

const es_ccsl_export_header_shot_number = /** @type {(inputs: Ccsl_Export_Header_Shot_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disparo #`)
};

const zh_cn2_ccsl_export_header_shot_number = /** @type {(inputs: Ccsl_Export_Header_Shot_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头#`)
};

const ja_ccsl_export_header_shot_number = /** @type {(inputs: Ccsl_Export_Header_Shot_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショット番号`)
};

const hi_ccsl_export_header_shot_number = /** @type {(inputs: Ccsl_Export_Header_Shot_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोली मारना #`)
};

const pt_pt2_ccsl_export_header_shot_number = /** @type {(inputs: Ccsl_Export_Header_Shot_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomada #`)
};

/**
* | output |
* | --- |
* | "Shot #" |
*
* @param {Ccsl_Export_Header_Shot_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_shot_number = /** @type {((inputs?: Ccsl_Export_Header_Shot_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Shot_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_shot_number(inputs)
	if (locale === "de") return de_ccsl_export_header_shot_number(inputs)
	if (locale === "it") return it_ccsl_export_header_shot_number(inputs)
	if (locale === "ru") return ru_ccsl_export_header_shot_number(inputs)
	if (locale === "es") return es_ccsl_export_header_shot_number(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_shot_number(inputs)
	if (locale === "ja") return ja_ccsl_export_header_shot_number(inputs)
	if (locale === "hi") return hi_ccsl_export_header_shot_number(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_shot_number(inputs)
	return en_ccsl_export_header_shot_number(inputs)
});